"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.array.sort");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const gatsby_1 = require("gatsby");
const use_debounce_1 = require("use-debounce");
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
const gatsby_plugin_google_analytics_1 = require("gatsby-plugin-google-analytics"); // Component
var SearchInHeader = function SearchInHeader() {
    var _React$useState = react_1.default.useState(""), keywordsInInput = _React$useState[0], setKeywordsInInput = _React$useState[1];
    var _useDebounce = use_debounce_1.useDebounce(keywordsInInput, 100), keywords = _useDebounce[0];
    var _React$useState2 = react_1.default.useState(), results = _React$useState2[0], setResults = _React$useState2[1];
    var _React$useState3 = react_1.default.useState(0), resultCount = _React$useState3[0], setResultCount = _React$useState3[1];
    var _React$useState4 = react_1.default.useState(3), limit = _React$useState4[0], setLimit = _React$useState4[1];
    var searchInput = react_1.default.useRef(null);
    var _React$useState5 = react_1.default.useState(false), processing = _React$useState5[0], setProcessing = _React$useState5[1];
    react_1.default.useEffect(function () {
        if (keywords.length === 0) {
            setResults(undefined);
            setResultCount(0);
            return;
        }
        if (keywords.length < 3)
            return;
        setLimit(3);
        setResults(undefined);
        setResultCount(0);
        setProcessing(true);
        fetch("https://search.prior.club/_search?q=" + encodeURIComponent(keywords) + "*").then(function (response) {
            return response.json();
        }).then(function (data) {
            setResultCount(data.hits.total.value); // 0.5s transition = 500 milliseconds
            setTimeout(function () {
                return setResults(transformDataToResults(data));
            }, 650);
            setProcessing(false);
            gatsby_plugin_google_analytics_1.trackCustomEvent({
                category: 'Internal Search',
                action: 'keyword search',
                label: keywords,
                value: data.hits.total.value
            });
        });
    }, [keywords]);
    var transformDataToResults = function transformDataToResults(data) {
        return data.hits.hits.filter(function (node) {
            return node._source.fields.thumbnailImageUrl;
        }).map(function (node) {
            var contentType = node._source.sys.contentType.sys.id === 'eventsAndJourneys' ? 'experiences' : node._source.sys.contentType.sys.id === 'knowledge' ? 'inspiration' : 'destinations';
            return {
                type: contentType,
                slug: node._source.fields.slug['en-US'],
                title: node._source.fields.title['en-US'],
                description: node._source.fields.socialSharingDescription['en-US'],
                thumbnailImageUrl: node._source.fields.thumbnailImageUrl['en-US'] || ""
            };
        }).sort(function (a, b) {
            var score = function score(result) {
                return result.type === 'experiences' ? -1 : result.type === 'inspiration' ? 0 : 1;
            };
            return score(a) - score(b);
        }).sort(function (a, b) {
            var score = function score(result) {
                var _result$description;
                return result.title.includes(keywords) ? -1 : ((_result$description = result.description) === null || _result$description === void 0 ? void 0 : _result$description.includes(keywords)) ? 0 : 1;
            };
            return score(a) - score(b);
        });
    };
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, {
        className: resultCount > 0 ? 'expand' : ''
    }, /*#__PURE__*/ react_1.default.createElement(StyledMargin, null, /*#__PURE__*/ react_1.default.createElement(Column, null, /*#__PURE__*/ react_1.default.createElement(ColumnHeader, null, "Search PRIOR"), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, Object.assign({
        type: "text",
        value: keywordsInInput,
        label: "Search\u2026",
        name: "keywords",
        onChange: function onChange(e) {
            return setKeywordsInInput(e.target.value);
        },
        inputRef: searchInput,
        icon: "search",
        autoComplete: "off"
    }, {
        processing: processing
    })), /*#__PURE__*/ react_1.default.createElement(Results, null, results === null || results === void 0 ? void 0 : results.slice(0, limit).map(function (result) {
        return /*#__PURE__*/ react_1.default.createElement(Result, {
            key: result.type + "-" + result.slug
        }, /*#__PURE__*/ react_1.default.createElement(Copy, null, /*#__PURE__*/ react_1.default.createElement(EntryType, null, result.type), /*#__PURE__*/ react_1.default.createElement(Title, null, result.title), /*#__PURE__*/ react_1.default.createElement(Description, null, result.description), /*#__PURE__*/ react_1.default.createElement(LinkWrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledLink, {
            to: "/" + result.type + "/" + result.slug
        }, "Read more"))), /*#__PURE__*/ react_1.default.createElement(ImageWrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledImage, {
            src: result.thumbnailImageUrl,
            objectFit: "cover",
            widthClass: "overlap"
        })), /*#__PURE__*/ react_1.default.createElement(atoms_1.LinkMask, {
            to: "/" + result.type + "/" + result.slug
        }, "$", result.title));
    })), results && resultCount > 3 && limit !== 9999 && /*#__PURE__*/ react_1.default.createElement(ButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        type: "outline",
        onClick: function onClick() {
            return setLimit(9999);
        },
        display: "flex"
    }, "Show more results")))));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "SearchInHeader__Wrapper",
    componentId: "sc-1bxj1iw-0"
})(["position:relative;display:flex-start;flex-direction:column;justify-content:center;background-color:", ";color:", ";padding:64px 0;", "{padding:80px 0;}", "{padding:96px 0;}", "{padding:128px 0;}min-height:300px;transition:min-height 2.0s cubic-bezier(0.215,0.61,0.355,1);will-change:min-height;&.expand{min-height:calc(100vh - 50px);transition:min-height 0.8s cubic-bezier(0.215,0.61,0.355,1);}"], _theme_1.palette.snow, _theme_1.palette.ink, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledMargin = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Margin, props);
}).withConfig({
    displayName: "SearchInHeader__StyledMargin",
    componentId: "sc-1bxj1iw-1"
})(["display:flex;flex-direction:column;flex-wrap:wrap;width:100%;max-width:380px;", "{width:560px;max-width:100%;}", "{width:672px;}", "{width:760px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Column = styled_components_1.default.div.withConfig({
    displayName: "SearchInHeader__Column",
    componentId: "sc-1bxj1iw-2"
})(["width:100%;&:last-of-type{padding-bottom:0 !important;}", "{padding:36px 0;border-top:1px solid ", ";}", "{padding:40px 0;}", "{padding:56px 0;}"], _utils_1.mediaQuery('tablet'), _utils_1.rgba(_theme_1.palette.ink, 0.16), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var ColumnHeader = styled_components_1.default.h2.withConfig({
    displayName: "SearchInHeader__ColumnHeader",
    componentId: "sc-1bxj1iw-3"
})(["display:none;", "{display:block;margin-bottom:28px;", " color:", ";}", "{margin-bottom:35px;}", "{margin-bottom:50px;}"], _utils_1.mediaQuery('tablet'), _theme_1.type.h2, _theme_1.palette.black, _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Results
var Results = styled_components_1.default.ul.withConfig({
    displayName: "SearchInHeader__Results",
    componentId: "sc-1bxj1iw-4"
})([""]);
var Result = styled_components_1.default.li.withConfig({
    displayName: "SearchInHeader__Result",
    componentId: "sc-1bxj1iw-5"
})(["position:relative;display:flex;flex-direction:column-reverse;padding-top:32px;", "{flex-direction:row;justify-content:space-between;padding-top:40px;}", "{padding-top:48px;}", "{padding-top:64px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Copy = styled_components_1.default.div.withConfig({
    displayName: "SearchInHeader__Copy",
    componentId: "sc-1bxj1iw-6"
})(["position:relative;height:fit-content;"]);
var EntryType = styled_components_1.default.div.withConfig({
    displayName: "SearchInHeader__EntryType",
    componentId: "sc-1bxj1iw-7"
})(["", " &::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.4) * 1em);}&::after{margin-bottom:calc((1 - 1.5) * 1em);}"], _theme_1.type.labelSmall);
var Title = styled_components_1.default.h3.withConfig({
    displayName: "SearchInHeader__Title",
    componentId: "sc-1bxj1iw-8"
})(["display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;padding-top:16px;overflow:hidden;text-overflow:ellipsis;", " color:", ";&::before,&::after{display:block;height:0;width:0;margin-top:calc((1 - 1.2) * 1em);content:'';}&::after{margin-top:calc((1 - 1) * 1em);}", "{transition:color 0.25s ease-in-out;", ":hover &{color:", ";}}", "{padding-top:24px;}"], _theme_1.type.h3, _theme_1.palette.black, _utils_1.mediaQuery('tablet'), Result, _theme_1.palette.brown, _utils_1.mediaQuery('desktop'));
var Description = styled_components_1.default.p.withConfig({
    displayName: "SearchInHeader__Description",
    componentId: "sc-1bxj1iw-9"
})(["display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;padding-top:16px;margin-top:-8px;overflow:hidden;text-overflow:ellipsis;", " &::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.3) * 1em);}&::after{margin-bottom:calc((1 - 1.05) * 1em);}", "{padding-top:24px;transform:translate3d(0,0,0);transition:transform 0.8s ease-in-out;", ":hover &{transform:translate3d(0,-4px,0);}}", "{padding-top:32px;}"], _theme_1.type.pSmall, _utils_1.mediaQuery('tablet'), Result, _utils_1.mediaQuery('desktop'));
var LinkWrapper = styled_components_1.default.div.withConfig({
    displayName: "SearchInHeader__LinkWrapper",
    componentId: "sc-1bxj1iw-10"
})(["padding-top:24px;margin-top:-6px;", "{padding-top:32px;}", "{padding-top:40px;}", "{padding-top:48px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledLink = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, props);
}).withConfig({
    displayName: "SearchInHeader__StyledLink",
    componentId: "sc-1bxj1iw-11"
})(["display:block;", " &::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.4) * 1em);}"], _theme_1.type.label);
var ImageWrapper = styled_components_1.default.div.withConfig({
    displayName: "SearchInHeader__ImageWrapper",
    componentId: "sc-1bxj1iw-12"
})(["position:relative;width:100%;max-width:100%;overflow:hidden;margin-bottom:32px;", "{width:200px;min-width:200px;max-width:200px;min-height:100%;margin-bottom:0;margin-left:32px;}", "{width:240px;min-width:240px;max-width:240px;}", "{width:280px;min-width:280px;max-width:280px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledImage = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Image, props);
}).withConfig({
    displayName: "SearchInHeader__StyledImage",
    componentId: "sc-1bxj1iw-13"
})(["", "{transform:scale3d(1,1,1);transition:transform 1.2s ease-in-out;", ":hover &{transform:scale3d(1.08,1.08,1);}}"], _utils_1.mediaQuery('tablet'), Result);
var ButtonWrapper = styled_components_1.default.div.withConfig({
    displayName: "SearchInHeader__ButtonWrapper",
    componentId: "sc-1bxj1iw-14"
})(["padding-top:32px;", "{padding-top:40px;}", "{padding-top:48px;}", "{padding-top:64px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Typing
exports.default = SearchInHeader;
